import UserCmDoc from "../../entities/UserCMDoc";

export function getFormatDate(date: string) {
  if (date && date.length) {
    const splitDate = date.split("-");
    return `${splitDate[2]}/${splitDate[1]}/${splitDate[0]}`;
  }
  return "";
}

export function getGenderLabel(gender: number) {
  switch (gender) {
    case 1:
      return "זכר";
    case 2:
      return "נקבה";
    default:
      return "לא ידוע";
  }
}

export function getMeritalStatusLabel(meritalStatus: number) {
  switch (meritalStatus) {
    case 1:
      return "נשוי/אה";
    case 2:
      return "רווק/ה";
    case 3:
      return "גרוש/ה";
    case 4:
      return "אלמן/ה";
    case 5:
      return "לא ידוע";
    default:
      return "לא ידוע";
  }
}

export function getCityLabel(citiesList: any, cityCode: string) {
  if (citiesList && citiesList.length && cityCode && cityCode.length) {
    const cityLabelArr = citiesList.filter(
      (city: any) => cityCode === city.cityCode
    );
    if (cityLabelArr.length) {
      return cityLabelArr[0]?.cityDescription?.trim();
    }
  }
  return "";
}

export function getCityCode(citiesList: any, cityLabel: string) {
  if (citiesList && citiesList.length && cityLabel && cityLabel.length) {
    const cityLabelArr = citiesList.filter(
      (city: any) => cityLabel === city.cityDescription
    );
    if (cityLabelArr.length) {
      return cityLabelArr[0]?.cityCode;
    }
  }
  return "";
}

export function getDeliveryOptionLabel(deliveryCode: string) {
  switch (deliveryCode) {
    case "001":
      return "בדוא''ל וגם בדואר רגיל";
    case "002":
      return "רק בדוא''ל";
    case "003":
      return "בדואר רגיל";
    case "004":
      return "רק במסרון sms";
    case "005":
      return "בדוא''ל וגם במסרון";
    default:
      return "";
  }
}

export function getDeliveryOptionCode(deliveryLabel: string) {
  switch (deliveryLabel) {
    case "בדוא''ל וגם בדואר רגיל":
      return "001";
    case "רק בדוא''ל":
      return "002";
    case "בדואר רגיל":
      return "003";
    case "רק במסרון sms":
      return "004";
    case "בדוא''ל וגם במסרון":
      return "005";
    default:
      return "";
  }
}

export function getCellphoneNumber(cellphone: string) {
  if (cellphone && cellphone.length) {
    if (cellphone.includes("-")) {
      return cellphone.split("-")[1];
    }
    return cellphone.slice(3, cellphone.length);
  }
  return "";
}

export function getUserIdWithZeros(userId: string) {
  if (!userId?.length) return "";

  if (userId.length === 9) return userId;

  let userIdWithZeros = "";
  for (let i = userId.length; i < 9; i++) {
    userIdWithZeros += "0";
  }
  return userIdWithZeros + userId;
}

export const isHaveYearlyReports = (reports: any) => {
  if (reports?.length) {
    const yearlyReports = reports.filter(
      (report: UserCmDoc) => report.DocDisplayName === "דוח לחבר שנתי"
    );
    return yearlyReports.length > 0;
  }
  return false;
};
